import { ReactNode } from 'react';
import { InteractiveCard, LocalizedSmallParagraph, LocalizedTypography } from '@mews-commander/ui';
import { Icon, IconName, Stack } from '@optimus-web/core';

interface SecurityCardProps {
    onClick?: () => void;
    primaryText: Mews.TextKey;
    secondaryText: Mews.TextKey;
    action?: ReactNode;
    children?: ReactNode;
}

const SECURITY_CARD_MIN_HEIGHT = 60;

export const SecurityCard = ({ onClick, primaryText, secondaryText, action, children }: SecurityCardProps) => (
    <InteractiveCard padding="300" onClick={onClick}>
        <Stack alignment="center" vertical style={{ minHeight: SECURITY_CARD_MIN_HEIGHT }}>
            <Stack distribution="space-between" itemAlignment={action ? 'center' : 'start'} spacing="200">
                <Stack fill vertical spacing="50" alignment="center">
                    <LocalizedTypography textKey={primaryText} textStyle="bodyMediumStrong" as="div" />
                    <LocalizedSmallParagraph textKey={secondaryText} />
                    {children}
                </Stack>

                {action || <Icon size="small" variant="info" value={IconName.ChevronRight} />}
            </Stack>
        </Stack>
    </InteractiveCard>
);
